import QueryStringParser from '../../../utils/query_string_parser';
import { parseActionParams } from '../../helpers/action_params_helper';

export const execute = (linkAction) => {
	const { url } = linkAction;
	const parsedParams = parseActionParams(linkAction, linkAction.params);
	const parsedURL = `${url}?${QueryStringParser.parseFromObject(parsedParams)}`;

	window.open(parsedURL);
	return Promise.resolve();
};

export default {
	execute
};
